import { render, staticRenderFns } from "./BorrowLendBooks.vue?vue&type=template&id=638e346c&scoped=true&"
import script from "./BorrowLendBooks.vue?vue&type=script&lang=js&"
export * from "./BorrowLendBooks.vue?vue&type=script&lang=js&"
import style0 from "./BorrowLendBooks.vue?vue&type=style&index=0&id=638e346c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e346c",
  null
  
)

export default component.exports